<div class="toast toast-top toast-center z-[100]">
	@for (msg of notify.messages(); track msg.id) {
		<div class="alert {{ msg.type }} shadow-lg animate-in fade-in slide-in-from-top-4">
			<span [innerHTML]="msg.text"></span>
		</div>
	}
</div>

<router-outlet />
<ziggy-confirm-dialog />
